import type { ComponentType } from 'react'
import type { LucideProps } from 'lucide-react-native'
import {
  Beer,
  Beef,
  Broccoli,
  Cake,
  CakeSlice,
  Candy,
  ChefHat,
  Coffee,
  Cookie,
  CookingPot,
  Croissant,
  Crown,
  CupSoda,
  Donut,
  Drumstick,
  Fish,
  Flame,
  Gift,
  Ham,
  Hamburger,
  Heart,
  IceCreamCone,
  Lollipop,
  Martini,
  Milk,
  Pizza,
  Popcorn,
  Popsicle,
  Salad,
  Sandwich,
  Soup,
  Sparkles,
  Star,
  Trophy,
  Utensils,
  Wine,
} from 'lucide-react-native'

export type CardIconKey =
  | 'Beer' | 'Beef' | 'Broccoli' | 'Cake' | 'CakeSlice' | 'Candy'
  | 'ChefHat' | 'Coffee' | 'Cookie' | 'CookingPot' | 'Croissant' | 'Crown'
  | 'CupSoda' | 'Donut' | 'Drumstick' | 'Fish' | 'Flame' | 'Gift'
  | 'Ham' | 'Hamburger' | 'Heart' | 'IceCreamCone' | 'Lollipop' | 'Martini'
  | 'Milk' | 'Pizza' | 'Popcorn' | 'Popsicle' | 'Salad' | 'Sandwich'
  | 'Soup' | 'Sparkles' | 'Star' | 'Trophy' | 'Utensils' | 'Wine'

export const CARD_ICON_COMPONENTS: Record<CardIconKey, ComponentType<LucideProps>> = {
  Beer,
  Beef,
  Broccoli,
  Cake,
  CakeSlice,
  Candy,
  ChefHat,
  Coffee,
  Cookie,
  CookingPot,
  Croissant,
  Crown,
  CupSoda,
  Donut,
  Drumstick,
  Fish,
  Flame,
  Gift,
  Ham,
  Hamburger,
  Heart,
  IceCreamCone,
  Lollipop,
  Martini,
  Milk,
  Pizza,
  Popcorn,
  Popsicle,
  Salad,
  Sandwich,
  Soup,
  Sparkles,
  Star,
  Trophy,
  Utensils,
  Wine,
}